import { just, Maybe, nothing } from 'maybeasy';
import { TPlainTextKey } from '../../../../../../../Translations';
import { FileMetaData } from '../S3ImageUpload/Types';

export interface Loading {
  kind: 'loading';
}

export interface Ready {
  kind: 'ready';
  fileMetaData: Maybe<FileMetaData>;
  message: Maybe<TPlainTextKey>;
}

export interface Error {
  kind: 'error';
  message: Maybe<TPlainTextKey>;
}

export interface Delete {
  kind: 'delete';
  fileMetaData: Maybe<FileMetaData>;
  message: Maybe<TPlainTextKey>;
}

export const loading = (): Loading => ({
  kind: 'loading',
});

export const ready = (fileMetaData: Maybe<FileMetaData>): Ready => ({
  kind: 'ready',
  fileMetaData,
  message: nothing(),
});

export const error = (message: TPlainTextKey): Error => ({
  kind: 'error',
  message: just(message),
});

export const deleteImage = (): Delete => ({
  kind: 'delete',
  fileMetaData: just({
    assetType: '',
    extension: '',
    fileName: '',
    objName: '',
  }),
  message: nothing(),
});

export type UploadImageState = Loading | Error | Ready | Delete;
